<template>
  <div>
    <!-- Desktop View: Buttons in a row -->
    <nav
      class="desktop-actions"
    >
      <v-btn
        v-for="(action, actionIndex) in actions"
        :key="`desktop-${actionIndex}`"
        :color="action.color || 'primary'"
        :disabled="isActionDisabled(action)"
        class="mb-2"
        @click="$emit('action-click', action)"
      >
        <div class="d-flex align-center" style="gap: 4px;">
          <v-icon>mdi-{{ action.icon }}</v-icon>
          {{ action.label }}
        </div>
      </v-btn>
    </nav>

    <div class="mobile-actions">
      <v-menu offset-y>
        <template #activator="{ on, attrs }">
          <v-btn color="primary" v-bind="attrs" v-on="on">
            Actions
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(action, actionIndex) in actions"
            :key="`mobile-${actionIndex}`"
            :disabled="isActionDisabled(action)"
            @click="$emit('action-click', action)"
          >
            <v-list-item-icon>
              <v-icon>mdi-{{ action.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ action.label }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListActions',
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    createPermission: {
      type: String,
      default: ''
    }
  },
  methods: {
    isActionDisabled (action) {
      const hasCreatePermission = this.createPermission ? !this.$store.getters.canPerformAction(this.createPermission) : false;
      return (action.mode === 'creer' ? hasCreatePermission : false) || action.disabled;
    }
  }
};
</script>

<style scoped>
.desktop-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.mobile-actions {
  display: none;
}
</style>
